// extracted by mini-css-extract-plugin
export default {"wrap":"OG-z","articleImagesWrap":"PG-z","articleImage":"QG-z","singleImage":"RG-z"};